module.exports = __webpack_public_path__ + "static/obenlinks-57bc6a5aacbad29d5aec19fcdfe608fb.jpg";